import { createApp } from 'vue'
import initApp from '@/engine'

import { trackTime } from '@wallbox/metrics'
import 'virtual:svg-icons-register'
import './styles/styles.css'
import appVue from './app.vue'

void (async () => {
  if (import.meta.env.VITE_MSW_ENABLED === 'true') {
    const { worker } = await import('@/mocks/browser')
    await worker.start({ onUnhandledRequest: 'warn' })
  }

  const app = createApp(appVue)

  const { i18n, router } = await initApp(app)

  app
    .use(i18n)
    .use(router)
    .mount('#app')

  trackTime('bootstrapping-complete')
})()
